import { AuthPageContentProps } from './types';

export const AuthPageContent = ({ children }: AuthPageContentProps) => (
    <div className="bg-white flex-1 px-4 pb-4 pt-12 md:pt-24">
        <div className="max-w-96 mx-auto">{children}</div>
    </div>
);
